import { Map, LayerSpecification } from "maplibre-gl";
import { LayerParams } from "../../map/layer-manager";
import { MapLayer } from "../map-layer";

/**
 * Camada do heatmap de contagem das ocorrências.
 */
export class EventHeatmapLayer extends MapLayer {

  /**
   * Construtor.
   * @param sourceId id da fonte de dados
   * @param layerId id da camada
   */
  constructor(private sourceId: string, private layerId: string) {
    super();
  }

  hasData(layerParams: LayerParams): boolean {
    let { gridData } = layerParams;
    return gridData != null && gridData.features.length > 0;
  }

  remove(map: Map): void {
    
    if (map.getLayer(this.layerId)) {
      map.removeLayer(this.layerId);
    }

    if (map.getSource(this.sourceId)) {
      map.removeSource(this.sourceId);
    }
  }

  show(map: Map, layerParams: LayerParams) {

    let { gridData: squareGridCounts, middleCounts: quartiles } = layerParams;

    // let squareGridCounts = this.countEventsInCells(layerParams);
    let opacities = this.getOpacities(quartiles);

    map.addSource(this.sourceId, {
      'type': 'geojson',
      'data': squareGridCounts,
    });

    let spec: LayerSpecification = {
      'id': this.layerId,
      'type': 'fill',
      'source': this.sourceId,
      'paint': {
        'fill-color': ['get', 'color'],
        // 'fill-color': [
        //   'interpolate',
        //   ['linear'],
        //   ['number', ['get', 'totalCell']],
        //   ...colors,
        // ],
        'fill-opacity': [
          'interpolate',
          ['linear'],
          ['get', 'totalCell'],
          ...opacities,
        ],
        'fill-outline-color': 'rgba(255,0,0,0)',
      }
    };

    map.addLayer(spec);
  }

  /**
   * Cria os arrays de cores e opacidades que devem ser aplicadas às contagens de ocorrências.
   * @param squareGridCounts grade quadriculada da contagem das ocorrências
   * @returns objeto com os arrays dos valores de cores e opacidades para os valores de contagens das ocorrências.
   */
  private getOpacities(quartiles: number[]) {

    let [q1, q2, q3] = quartiles;

    let opacities = [
      0, 0,
      q1, 0.8,
    ];

    return opacities;
  }

}
